import { render, staticRenderFns } from "./EipRealtimeTextarea.vue?vue&type=template&id=08dbef62&scoped=true&"
import script from "./EipRealtimeTextarea.vue?vue&type=script&lang=js&"
export * from "./EipRealtimeTextarea.vue?vue&type=script&lang=js&"
import style0 from "./EipRealtimeTextarea.vue?vue&type=style&index=0&id=08dbef62&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dbef62",
  null
  
)

export default component.exports